var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ql-container bottom-footer"},[_c('div',{staticClass:"ql-editor btm-ctn",domProps:{"innerHTML":_vm._s(_vm.$utils.textRepl(_vm.content))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }